import { render, staticRenderFns } from "./ChoiceSingleFeedback.vue?vue&type=template&id=3a073a38&scoped=true&"
import script from "./ChoiceSingleFeedback.vue?vue&type=script&lang=js&"
export * from "./ChoiceSingleFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceSingleFeedback.vue?vue&type=style&index=0&id=3a073a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a073a38",
  null
  
)

export default component.exports